<dw-ui-panel [defaultOpenedPanel]="infoPanel" [triggers]="triggers()">
  @if (entitySignal()?.id) {
    <div header-start class="mx-3">
      <document-number-tag [docRole]="entitySignal().role" [number]="entitySignal().displayNumber">
      </document-number-tag>

      <document-quote-version-select
        [docId]="entitySignal().id"
        (versionLoaded)="onVersionLoaded($event)"
      ></document-quote-version-select>
    </div>
  }
  <dw-grid-detail-navigation
    header-actions
    [context]="[
      GoliathDocumentEntityNames.CustomerQuote.shortName,
      GoliathDocumentEntityNames.CustomerDoc.shortName,
    ]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-3 mt-2 header">
                    <document-core-card
                      [form]="form"
                      [entity]="entity"
                      [displayCustomerProjectSelect]="true"
                      class="card"
                    ></document-core-card>

                    <document-customer-date-card
                      [form]="form"
                      [secondDate]="{
                        label: 'Doc::CustomerQuote:ValidityDate',
                        controlName: 'validityDate',
                        required: true,
                      }"
                      class="card"
                    >
                      <div class="row row-cols-md-12" afterSecondDate>
                        <div class="col-md-12 p-0">
                          <label for="requestedDeliveryDate" class="form-label text-primary">
                            {{ 'Doc::CustomerQuote:RequestedDeliveryDate' | abpLocalization }}
                          </label>
                          <dw-core-date-picker
                            formControlName="requestedDeliveryDate"
                          ></dw-core-date-picker>
                        </div>
                      </div>
                    </document-customer-date-card>

                    <document-customer-card
                      [form]="form"
                      [docRoleInput]="docRole"
                      [thirdPartySelect]="thirdPartySelect"
                      [thirdPartyContacts$]="thirdPartyContacts$"
                      [thirdPartyDeliveryAddresses$]="thirdPartyDeliveryAddresses$"
                      (redirectToThirdPartyEvent)="
                        redirectToThirdParty($event.thirdPartyId, $event.addContact)
                      "
                      class="card card-double"
                    ></document-customer-card>

                    <document-customer-status-card [form]="form" [docRole]="docRole" class="card">
                      <div class="row row-cols-md-12 col-pad" afterDocOrigin>
                        <div class="col-md-2 p-0" [dwReadonlyForm]="true">
                          <label for="versionNumber" class="form-label text-primary">
                            {{ 'Doc::CustomerQuote:VersionNumber' | abpLocalization }}
                          </label>
                          <input type="text" class="form-control" formControlName="versionNumber" />
                        </div>

                        <div class="col-md-4">
                          <label for="versionName" class="form-label text-primary">
                            {{ 'Doc::CustomerQuote:VersionName' | abpLocalization }}
                          </label>
                          <input type="text" class="form-control" formControlName="versionName" />
                        </div>

                        <div class="col-md-6 p-0">
                          <label
                            for="quoteStatusId"
                            class="form-label text-primary"
                            dwInputRequired
                          >
                            {{ 'Doc::QuoteStatus' | abpLocalization }}
                          </label>
                          <ng-select
                            class="form-control"
                            id="quoteStatusId"
                            formControlName="quoteStatusId"
                            bindLabel="name.current"
                            bindValue="id"
                            [loading]="enumerationTypeStore.loading()"
                            [items]="enumerationTypeStore.quoteStatus()"
                          >
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-6 p-0" afterDescription>
                        <label for="estimatedAvailability" class="form-label text-primary">
                          {{ 'Doc::CustomerQuote:EstimatedAvailability' | abpLocalization }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="estimatedAvailability"
                        />
                      </div>
                    </document-customer-status-card>
                  </div>

                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-quote-lines-grid
                        #quoteLineGrid
                        [customerQuote]="entity"
                        [readonly]="
                          isClosed() || (!entitySignal()?.isIntern && !entitySignal().isDraft)
                        "
                        [thirdPartyVatSystem]="thirdParty?.vatSystem"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        (linePricingDetailsEvent)="updatePricingDetails($event)"
                      ></document-quote-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'conditions'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-terms me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Conditions' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-conditions class="d-block" [docForm]="form" [docRoleInput]="docRole">
              </document-doc-conditions>
              <document-doc-funding [form]="form" [doc]="entitySignal()"></document-doc-funding>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-classifications
                class="d-block"
                [form]="form"
                [docClassificationValues]="docClassificationValues$ | async"
              ></document-doc-classifications>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'addresses'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-pin me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Addresses' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-customer-addresses
                class="d-block"
                [docForm]="form"
                [deliveryAddresses$]="thirdPartyDeliveryAddresses$"
                [invoicingAddresses$]="thirdPartyInvoicingAddress$"
                [pointOfSales$]="pointOfSales$"
                [workingSites$]="workingSites$"
                [docRoleInput]="docRole"
                [IsWebOrigin]="form.get('docOriginId').value == docOrigin.Web"
                (workingSiteSelected)="onWorkingSiteChanged($event)"
                (pointOfSaleSelected)="onPointOfSaleChanged($event)"
              ></document-doc-customer-addresses>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-customer-others
                class="d-block"
                [docForm]="form"
                [docRoleInput]="docRole"
                [isIntern]="entitySignal()?.isIntern"
              ></document-doc-customer-others>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <core-annexes-list
                [canDownload]="true"
                [canUpload]="true"
                [canDelete]="true"
                [canPreview]="true"
                [canEdit]="true"
                [folderName]="'quote-detail/' + entity?.id"
                [annexes]="annexesAsPromise$ | async"
                (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
                (deleteAnnex)="deleteAnnex($event)"
                (deleteAnnexes)="deleteAnnexes($event)"
              ></core-annexes-list>
            </div>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      <doc-save-action-buttons [buttons]="saveActionBtns()" [saving]="isSaving()" />
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <document-side-panel
          [entity]="entity"
          [docService]="docService"
          [linePricingDetails]="linePricingDetails"
          [thirdPartyContact$]="thirdPartyContact$"
          [thirdPartyDocLinkedCount]="thirdPartyDocLinkedCount"
          [contactEmail]="contactEmail"
          [contactPhone]="contactPhone"
          [customerAddress]="customerAddress"
          [deliveryAddressForm]="thirdPartyDeliveryAddress()"
          [accountingCustomerOutstandingDto]="accountingCustomerOutstandingDto"
          [thirdParty]="thirdParty"
          [creditLimit]="creditLimit"
          [customerProjectId]="customerProjectId()"
          (redirectToThirdPartyEvent)="redirectToThirdParty($event.thirdPartyId, $event.addContact)"
        >
          <label for="note" class="form-label text-primary mt-3">{{
            'GoliathCore::Note' | abpLocalization
          }}</label>
          @if (entity != null) {
            <textarea
              name="note"
              class="flex-grow-1"
              resize="none"
              [(ngModel)]="entity.note"
              (input)="updateNote($event)"
            ></textarea>
          }
        </document-side-panel>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel #history [contentTemplate]="bodyHistory">
      <ng-template #bodyHistory>
        <div class="history__container">
          <dw-core-history
            [entityId]="entity?.id"
            [entityName]="GoliathDocumentEntityNames.CustomerQuote.fullName"
          ></dw-core-history>
        </div>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.CustomerQuote.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>

<ng-template #report let-offcanvas>
  <dw-ui-dialog-box [title]="'Reporting::Report:ReportPdf'" [displayFooter]="false">
    <dw-report-viewer
      [reportName]="docRole"
      [dataId]="entity.id"
      [templateId]="printTemplateId"
      (pdfRequested)="downloadPdfReport()"
    ></dw-report-viewer>
  </dw-ui-dialog-box>
</ng-template>
